import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { ThemeProvider } from './theme';

const rootElement = document.getElementById('root') as HTMLElement;

const app = (
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// react-snap prerenders each route to static HTML at build time. When that markup
// is present we hydrate it (this also reconciles the per-page <title>/<meta>/<link>
// tags React hoists to <head>, avoiding duplicates); otherwise (e.g. dev) we render.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}

reportWebVitals();
